/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerReissueOneOf
 */
export interface GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerReissueOneOf {
    /**
     * 
     * @type {string}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerReissueOneOf
     */
    'cardType': GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerReissueOneOfCardTypeEnum;
    /**
     * Expiration date of the previous virtual card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerReissueOneOf
     */
    'expiredDate': string;
}

export const GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerReissueOneOfCardTypeEnum = {
    virtual: 'virtual'
} as const;

export type GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerReissueOneOfCardTypeEnum = typeof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerReissueOneOfCardTypeEnum[keyof typeof GetTeamsCardNotificationSettings200ResponseInnerUserAccountsInnerReissueOneOfCardTypeEnum];


